import { StatusPill, type Tone } from '~/shared/ui'
import type { PolicyDisplayState } from './BenefitPolicyService'

/** Tone for each server-derived display state. */
const DISPLAY_STATE_TONE: Record<PolicyDisplayState, Tone> = {
  draft: 'warning',
  active: 'success',
  upcoming: 'info',
  expired: 'neutral',
}

const DISPLAY_STATE_LABEL: Record<PolicyDisplayState, string> = {
  draft: 'Draft',
  active: 'Active',
  upcoming: 'Upcoming',
  expired: 'Expired',
}

interface PolicyStatusPillProps {
  displayState: PolicyDisplayState
  testId?: string
}

/**
 * One policy's lifecycle state.
 *
 * Shared by the list and the editor so a row and the screen it opens cannot label the same policy
 * differently. The state itself is always the server's — the client never derives one from dates.
 */
export const PolicyStatusPill = ({ displayState, testId }: PolicyStatusPillProps) => (
  <StatusPill
    tone={DISPLAY_STATE_TONE[displayState]}
    label={DISPLAY_STATE_LABEL[displayState]}
    data-testid={testId}
  />
)
